import React from 'react';

import { LoadingButtonProps } from '@mui/lab';

import { StyledButton } from './index.styles';

export interface ButtonProps extends LoadingButtonProps {
  /**
   * If `true`, the button text is all caps
   */
  allCaps?: boolean,
  rounded?: boolean,
  /**
   * Ref for the inner button component
   */
  buttonRef?: React.RefObject<HTMLButtonElement>,
}

const Button = ({ buttonRef, rounded = true, variant = 'outlined', size = 'medium', allCaps = false, color = 'darkPrimary', children, ...rest }: ButtonProps) => (
  <StyledButton
    ref={buttonRef}
    variant={variant}
    color={color}
    size={size}
    disableElevation
    $allCaps={allCaps}
    $rounded={rounded}
    {...rest}
  >
    {children}
  </StyledButton>
);

export default Button;
